module.exports = __webpack_public_path__ + "static/media/rchic.bd03f1e4.png";